<template>
  <nav
    class="navigation"
    @focusout="hideFlyout($event)"
  >
    <ul
      id="MAIN_NAVIGATION_MENU"
      class="navigation__list"
    >
      <li
        v-for="(category, index) in shopCategoriesTree"
        :key="`category_${index}`"
        class="navigation__element"
        :aria-label="$t('global.category.aria.label',[category.name])"
        :class="{ 'navigation__active': this.toggledStates[index] }"
      >
        <component
          :is="withHeadline ? 'h2' : 'div'"
          class="navigation__ignore-h2"
        >
          <a
            :href="category.url"
            class="navigation__link"
            @focus="this.toggledStates = this.toggledStates.map(() => false)"
          >{{ category.name }}</a>
          <div
            class="navigation__button"
            @keydown="toggleFlyout(index, $event)"
            tabindex="0"
          />
          <navigation-flyout
            v-if="category.subcategories && category.subcategories.length"
            class="navigation__flyout"
            :categories="category.subcategories"
            :flyout-image="category.flyoutImage"
          />
        </component>
      </li>
    </ul>
  </nav>
</template>

<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import NavigationFlyout from '../navigationFlyout/navigationFlyout.vue';

  export default {
    mixins: [
      globalStateComputedMixin
    ],
    components: {
      NavigationFlyout
    },
    props: {
      withHeadline: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        toggledStates: []
      };
    },
    mounted() {
      this.toggledStates = new Array(this.shopCategoriesTree.length).fill(false);
    },
    methods: {
      toggleFlyout(index, event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          this.toggledStates[index] = !this.toggledStates[index];
        }
      },
      hideFlyout(event) {
        const navigationElement = this.$el;
        if (!navigationElement.contains(event.relatedTarget)) {
          this.toggledStates = this.toggledStates.map(() => false);
        }
      }
    }
  };

</script>
